import { render, staticRenderFns } from "./item-learn.vue?vue&type=template&id=500b768a&"
import script from "./item-learn.vue?vue&type=script&lang=js&"
export * from "./item-learn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports